import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@homeaway/react-tooltip';
import "./SupportLinks.css";

function SupportLinks(_ref) {
  var contact = _ref.contact,
      issues = _ref.issues;
  return /*#__PURE__*/React.createElement("section", {
    className: "SupportLinks"
  }, !!contact && contact.name && contact.url && contact.type === 'slack' && /*#__PURE__*/React.createElement(Tooltip, {
    centered: true,
    interactiveContainer: true,
    placement: "bottom",
    content: "#" + contact.name
  }, /*#__PURE__*/React.createElement("a", {
    href: contact.url,
    className: "SupportLinks__contact-link",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("svg", {
    height: "32",
    viewBox: "0 0 80 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 17c.5.3.5.5 0 1.4s-.5 1-1 .7a6.6 6.6 0 0 0-2.4-.5c-1 0-1.6.3-1.6.9 0 1.8 5.6.8 5.6 4.6 0 2-1.6 3.2-4 3.2a9.7 9.7 0 0 1-4-1c-.6-.3-.6-.4-.2-1.3s.6-.9 1.2-.6a8.4 8.4 0 0 0 3 .7c.8 0 1.4-.4 1.4-1 0-1.7-5.8-.8-5.8-4.5 0-2 1.7-3.3 4.1-3.3a9.5 9.5 0 0 1 3.6.8zm4.5-4.5v14.2a.5.5 0 0 1-.6.5h-1.4a.5.5 0 0 1-.6-.5V12.6c0-.7.2-.8 1.3-.8s1.3 0 1.3.8zm10.6 8v6.1a.5.5 0 0 1-.6.6h-1.4a.5.5 0 0 1-.6-.6v-.7a4.2 4.2 0 0 1-3 1.4c-2.3 0-3.8-1.3-3.8-3.2s1.7-3.4 4.2-3.4a6.6 6.6 0 0 1 2.6.4v-.7c0-1.1-.9-1.8-2.4-1.8a4.7 4.7 0 0 0-2.2.7c-.6.3-.7.3-1.3-.6s-.5-1 0-1.3a7.3 7.3 0 0 1 3.8-1.1c2.9 0 4.7 1.5 4.7 4.2zM45.2 24c0 .7.6 1.2 1.6 1.2a3.2 3.2 0 0 0 2.7-1.4v-1a5.7 5.7 0 0 0-2-.3c-1.4 0-2.3.6-2.3 1.5zm17-7c.6.3.6.5 0 1.4s-.6 1-1.2.6a4.2 4.2 0 0 0-1.8-.4 3 3 0 0 0-3.2 3.1 3 3 0 0 0 3.1 3.3 4.5 4.5 0 0 0 2-.6c.6-.3.7-.2 1.3.6s.5 1 0 1.3a6.3 6.3 0 0 1-3.3 1c-3.5 0-5.8-2.2-5.8-5.5s2.3-5.5 5.8-5.5a6.9 6.9 0 0 1 3 .8zm11.3 8.7c.4.6.2.8-.8 1.2s-1.3.4-1.7-.2l-3-4-1.5 1.3v2.7a.5.5 0 0 1-.5.4h-1.5a.5.5 0 0 1-.6-.4V12.6c0-.7.2-.8 1.3-.8s1.3 0 1.3.8v8l4.2-4c.5-.5.8-.5 1.6 0s1 .8.5 1.3l-3.1 3 3.8 5zM14.2 20.7l2.5-.8.8 2.4-2.5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2 20.7l2.5-.8.8 2.4-2.5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 18.9c-2-6.5-4.8-8-11.3-6.1s-8 4.8-6 11.3 4.7 8 11.2 6.1 8-4.8 6.1-11.3zM21.2 23l-1.2.4.4 1.3a1 1 0 0 1-.6 1.3 1 1 0 0 1-1.2-.7l-.5-1.2-2.5.8.4 1.3a1 1 0 0 1-.6 1.2A1 1 0 0 1 14 27l-.4-1.3-1.2.4a1 1 0 0 1-1.3-.6A1 1 0 0 1 12 24l1.2-.4-.8-2.4-1.2.4a1 1 0 0 1-1.3-.6 1 1 0 0 1 .6-1.3l1.3-.4-.5-1.3A1 1 0 0 1 12 17a1 1 0 0 1 1.2.6l.4 1.3L16 18l-.5-1.3a1 1 0 0 1 .8-1.2 1 1 0 0 1 1.1.6l.4 1.3 1.3-.4a1 1 0 0 1 .6 1.8l-1.2.4.8 2.5 1.2-.4a1 1 0 0 1 .6 1.8z"
  })))), !!issues && issues.name && issues.url && issues.type === 'jira' && /*#__PURE__*/React.createElement(Tooltip, {
    centered: true,
    interactiveContainer: true,
    placement: "bottom",
    content: issues.name + " issue tracker"
  }, /*#__PURE__*/React.createElement("a", {
    href: issues.url,
    className: "SupportLinks__issues-link",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("svg", {
    height: "32",
    viewBox: "0 0 80 40"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "18.6",
    y1: "28.7",
    x2: "13.9",
    y2: "24.1",
    gradientTransform: "matrix(1 0 0 -1 0 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".2",
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#2684ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "19.8",
    y1: "15.3",
    x2: "24.5",
    y2: "20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.9 11.4h2.3v12c0 3.2-1.4 5.4-4.6 5.4a8.5 8.5 0 0 1-2.9-.5V26a6.8 6.8 0 0 0 2.5.5c2 0 2.7-1.3 2.7-3zM47.5 10.4a1.5 1.5 0 0 1 1.6 1.4.7.7 0 0 1 0 .2 1.6 1.6 0 1 1-3.1 0 1.5 1.5 0 0 1 1.4-1.6zm-1.1 5.1h2.2v13.1h-2.2zM52 15.5h2.3v2.3a4.3 4.3 0 0 1 4.6-2.5v2.2c-2.9-.3-4.6.6-4.6 3.4v7.7H52zM69.5 26.3a4.6 4.6 0 0 1-4.4 2.6c-3.5 0-5.3-3-5.3-6.8s1.9-6.9 5.5-6.9a4.3 4.3 0 0 1 4.2 2.6v-2.3h2.3v13.1h-2.3zm-3.8.5c2 0 3.8-1.3 3.8-4.2v-1c0-3-1.6-4.3-3.6-4.3-2.5 0-3.8 1.7-3.8 4.8s1.2 4.7 3.6 4.7z",
    fill: "#253858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9 19.4L20 9.6l-1-1-7.3 7.4-3.3 3.4a.9.9 0 0 0 0 1.2l6.7 6.7 4 4 7.3-7.3.1-.1 3.2-3.2a.9.9 0 0 0 0-1.3zm-10.7 4L15.8 20l3.4-3.3 3.3 3.3z",
    fill: "#2684ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2 16.7a5.6 5.6 0 0 1 0-8L11.8 16l4 4z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 20l-3.3 3.4a5.7 5.7 0 0 1 0 8l7.3-7.4z",
    fill: "url(#b)"
  })))));
}

SupportLinks.propTypes = {
  contact: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
    url: PropTypes.string
  }),
  issues: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
    url: PropTypes.string
  })
};
export default SupportLinks;
//# sourceMappingURL=SupportLinks.js.map